<template>
  <div class="content">
    <h3 v-html="content.name"></h3>
    <div v-html="content.content" ></div>
  </div>
</template>

<script type="text/babel">
import axios from 'axios'
export default {
  data () {
    return {
      content: [],
      params: this.$route.params
    }
  },
  methods: {
    getContent () {
      let data = {id: this.params.articleid}
      axios
        .post('/cat/content', data)
        .then(this.getContentSucc)
    },
    getContentSucc (res) {
      res = res.data
      if (res.status && res.data) {
        this.content = res.data
      }
    },
    HistoryBack () {
      window.history.back()
    }
  },
  mounted () {
    this.getContent()
  }
}
</script>

<style lang="stylus" scoped>
  .content
    min-height: 8rem
    background-color: rgba(255,255,255,0.15)
    padding: .2rem .26rem .4rem .26rem
    border-radius: .2rem
    font-size: .26rem
    line-height: 1.5
  .content h3
    font-weight: bold
    line-height: 1.3
    max-width: 60%
    margin: 0 auto
    padding: .2rem 0
    text-align: center
    color: #23cbcc
</style>



// WEBPACK FOOTER //
// src/views/template1/Content.vue